<div class="row" *ngIf="!busy && misdatos && (misdatos | keyvalue)?.length && misdatos.ID != 0">
  <div class="col-auto">
    <button class="btn btn-primary ps-4 pe-4" (click)="goOpcion('perfiles')"><i class="fa-solid fa-paw"></i> Mascotas</button>
  </div>
  <div class="col-auto">
    <button class="btn btn-white ps-4 pe-4" (click)="goOpcion('perfil'+'/'+misdatos.slug)">Mi perfil</button>
  </div>
</div>
<div class="row" *ngIf="!busy && misdatos && (misdatos | keyvalue)?.length && misdatos.ID == 0">
  <div class="col-auto">
    <button class="btn btn-primary ps-4 pe-4" (click)="goOpcion('login')"><i class="fa-solid fa-user"></i> Acceder</button>
  </div>
  <div class="col-auto">
    <button class="btn btn-white ps-4 pe-4" (click)="goOpcion('register')"><i class="fa-solid fa-user-plus"></i> Registro</button>
  </div>
</div>
